import { TimelineMax, Power3 } from 'gsap';

const MenuContentLabelHover = (element, split) => {
  const tl = new TimelineMax({ paused: true });
  tl.addLabel('start')
    .staggerTo(split.chars, 0.3, {
      yPercent: 0,
      autoAlpha: 1,
      ease: Power3.easeInOut,
    }, 0.02, 'start');
  return tl;
};

export default MenuContentLabelHover;
